<template>
  <main>
    <div id="modal1" class="modal">
      <div class="modal-content">
        <h4>Eliminar usuario</h4>
        <p>Estas a punto de eliminar a {{usuarioSeleccionado.nombre}}, esta accion no se puede revertir, ¿estas seguro que deseas eliminarlo?</p>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat">Volver</a>
        <a class="modal-close waves-effect waves-green btn-flat" @click="eliminar">Eliminar</a>
      </div>
    </div>
    <div class="row right-align main">

      <div class="col card-panel recargas">
        <form>
          <div class="input-field col s12">
            <i class="fa fa-building prefix icono-izquierda" aria-hidden="true"></i>
            <select v-model="opcion">
              <option value="registrar">Registrar nuevo</option>
              <option value="consultar">Consultar existentes</option>
            </select>
            <label>Opciones</label>
          </div>
          <div class="input-field col s12" v-show="opcion==='consultar'">
            <i class="fa fa-building prefix icono-izquierda" aria-hidden="true"></i>
            <select v-model="usuarioValue">
              <option value="0" disabled selected>Elige un usuario</option>
              <option v-for="usuario in usuarios" :value="usuario.id">{{usuario.username}}</option>
            </select>
            <label>Usuarios</label>
          </div>
        </form>
      </div>
      <div class="col card-panel movimientos">
        <div  v-show="opcion==='registrar'">
          <span class="titulo center-align">Registrar</span>
          <form >
            <div class="input-field col s10 push-s1">
              <i class=" icons-in-form large material-icons prefix">account_circle</i>
              <input v-model="username" id="username" type="text" maxlength="50" >
              <label for="username">Username</label>
            </div>
            <div class="input-field col s10 push-s1">
              <i class="icons-in-form large material-icons prefix ">accessibility</i>
              <input v-model="nombre" id="nombreCompleto" type="text" maxlength="100">
              <label for="nombreCompleto">Nombre completo</label>
            </div>
            <div class="input-field col s10 push-s1" >
              <i class="icons-in-form large material-icons prefix ">accessibility</i>
              <input v-model="numeroTel" id="numeroTel" type="text" maxlength="13">
              <label for="numeroTel">Número de teléfono</label>
            </div>
            <div class="input-field col s10 push-s1">
              <i class="icons-in-form large material-icons prefix ">fingerprint</i>
              <input v-model="password" id="password" type="password">
              <label for="password">Contraseña</label>
            </div>
            <div class="input-field col s10 push-s1">
              <i class="icons-in-form large material-icons prefix ">check_circle</i>
              <input v-model="confirmPassword" id="confirmPassword" type="password" >
              <label for="confirmPassword">Confirmacion de contraseña</label>
            </div>
            <div class="input-field col s10 push-s1">
              <select v-model="nivel">
<!--                <option v-if="miNivel==='1'" value="1">Administrador</option>-->
                <option  v-if="miNivel==='1'" value="2">Vendedor/Lider</option>
                <option v-if="(permisos.includes('USUARIO_CLIENTE'))" value="3">Cliente</option>
              </select>
              <label class="etiquetas">Tipo de usuario</label>
            </div>
            <div class="input-field col s5 push-s1">
              <select v-model="selectedLider">
                <option value="0" v-if="miNivel==='1'">Sin lider</option>
                <option v-for="lider in lideres" :value="lider">{{lider}}</option>
              </select>
              <label class="etiquetas">Asociar un lider</label>
            </div>
            <div class="input-field col s5 offset-s1">
              <i class="icons-in-form large material-icons prefix ">block</i>
              <input v-model="maxRecargas" id="maxRecargas" type="number" min="1" max="1000000" >
              <label for="maxRecargas">Máximo de recargas al día</label>
            </div>
            <div v-show="selectedLider.length>1 && nivel==='3'" class="input-field col s10 push-s1">
              <input type="text" v-model="selectedCliente" list="selectedClientes" id="inputCliente" >
              <label for="inputCliente">Asociar un cliente</label>
              <datalist id="selectedClientes">
                <option v-for="cliente in clientes" :value="cliente" />
              </datalist>
            </div>
            <span class="mensaje-error col s12 center">{{mensaje}}</span>
            <div class="waves-effect waves-light btn-large blue-grey darken-1 boton-margen-derecho col s5 push-s1"
                 @click="limpiarRegistro"><i class="material-icons left" aria-hidden="true">clear_all</i> Limpiar
            </div>
            <div class="waves-effect waves-light btn-large blue-grey darken-3 boton-margen-izquierdo col s5 push-s1"
                 @click="registrar"><i class="fa fa-check left" aria-hidden="true"></i> Registrar
            </div>
          </form>
        </div>
        <div  v-show="opcion==='consultar'">
          <span class="titulo center-align">{{usuarioSeleccionado.username}}.</span>
          <a v-show="usuarioSeleccionado.username" class="btn-floating btn-large waves-effect waves-light red eliminar modal-trigger" href="#modal1"><i class="material-icons">delete</i></a>
          <form >
            <div class="input-field col s10 push-s1">
              <i class="icons-in-form large material-icons prefix">accessibility</i>
              <input v-model="nombreEditar" id="nombreEditar" type="text" maxlength="100">
              <label for="nombreEditar">Nombre completo</label>
            </div>
            <div class="input-field col s10 push-s1" >
              <i class="icons-in-form large material-icons prefix ">accessibility</i>
              <input v-model="numeroTele" id="numeroTele" type="text" maxlength="13">
              <label for="numeroTele">Número de teléfono</label>
            </div>
            <div class="input-field col s10 push-s1">
              <i class="icons-in-form large material-icons prefix">fingerprint</i>
              <input v-model="passwordEditar" id="pass-ed" type="password">
              <label for="pass-ed">Contraseña</label>
            </div>
            <div class="input-field col s10 push-s1">
              <i class="icons-in-form large material-icons prefix">check_circle</i>
              <input v-model="confirmarPasswordEditar" id="confirm-ed" type="password">
              <label for="confirm-ed">Confirmación de contraseña</label>
            </div>
            <div class="input-field col s10 push-s1">
              <select v-model="nivelEditar">
<!--                <option v-if="miNivel==='1'" value="1" >Administrador</option>-->
                <option v-if="miNivel==='1'" value="2">Vendedor/Lider</option>
                <option v-if="(permisos.includes('USUARIO_CLIENTE'))" value="3">Cliente</option>
              </select>
              <label class="etiquetas">Tipo de usuario</label>
            </div>
            <div class="input-field col s5 push-s1">
              <select v-model="selectedLiderEditar">
                <option v-if="miNivel==='1'" value="0">Sin lider</option>
                <option v-for="lider in lideres" :value="lider">{{lider}}</option>
              </select>
              <label class="etiquetas">Asociar un lider</label>
            </div>
            <div class="input-field col s5 offset-s1">
              <i class="icons-in-form large material-icons prefix ">block</i>
              <input v-model="maxRecargasEditar" id="maxRecargasEdit" type="number" min="1" max="1000000" >
              <label for="maxRecargasEdit">Máximo de recargas al día</label>
            </div>
            <div v-show="selectedLiderEditar && selectedLiderEditar.length>1 && nivelEditar==='3'" class="input-field col s10 push-s1">
              <input type="text" v-model="selectedClienteEditar" list="editClientes" id="inputClienteEditar" >
              <label for="inputClienteEditar">Asociar un cliente</label>
              <datalist id="editClientes">
                <option v-for="cliente in clientes" :value="cliente" />
              </datalist>
            </div>
            <span class="mensaje-error col s12 center">{{mensaje}}</span>
            <div class="waves-effect waves-light btn-large blue-grey darken-1 boton-margen-derecho col s5 push-s1"
                 @click="limpiarEditar"><i class="material-icons left" aria-hidden="true"> clear_all </i> Limpiar
            </div>
            <div class="waves-effect waves-light btn-large blue-grey darken-3 boton-margen-izquierdo col s5 push-s1"
                 @click="editar"><i class="fa fa-check left" aria-hidden="true"></i> Editar
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import {getUsuarios, registrarUsuario, editarUsuario,eliminarUsuario, getLideres , getClientes} from '@/api/api'
  import {mapState} from 'vuex'
  let clientesStore = []

  export default {
    name: "usuarios",
    data() {
      return {
        usuarios: [],
        usuariosM: [],
        numeroTel: null,
        numeroTele: null,
        usuarioValue: '0',
        liderValue:'0',
        usuarioSeleccionado:{},
        mensaje: '',
        username: '',
        nombre:'',
        nombreEditar:'',
        password: '',
        passwordEditar:'',
        confirmPassword: '',
        confirmarPasswordEditar:'',
        nivelEditar:'1',
        nivel:'1',
        opcion:'registrar',
        lideres:[],
        selectedLider:'0',
        selectedLiderEditar:'0',
        maxRecargas:'100000',
        maxRecargasEditar:'',
        selectedCliente:'',
        selectedClienteEditar:'',
        clientes:[],
        miNivel:''
      }
    },
    mounted() {
      this.miNivel=localStorage.nivel
      this.nivel = this.miNivel==='2'? '3':'1'
      this.nivelEditar = this.miNivel==='2'? '3':'1'
      this.selectedLiderEditar = localStorage.lider
      console.log(159)
      this.$nextTick(()=>{
        M.AutoInit()
        M.updateTextFields()
        this.getUsers()
      })
    },
    methods: {
      getUsers(){
        getUsuarios().then(respuesta => {
          this.usuarios=respuesta.usuarios
          this.$nextTick(()=>M.AutoInit())
        }).catch(error => {
          console.log(error)
        })


        if (localStorage.nivel<2){
          getLideres().then(respuesta => {
            this.lideres = respuesta.lideres
            this.$nextTick(()=>M.AutoInit())
          }).catch(error => {
            console.log(error)
          })
        }else{
          this.selectedLider = localStorage.lider
          this.lideres = [localStorage.lider]
        }


        getClientes().then(respuesta =>{
          clientesStore = respuesta.clientes
          if (this.miNivel==='2'){
            this.clientes = clientesStore.filter(clienteLider=>clienteLider.lider===this.selectedLider ).map(clienteLider=>clienteLider.cliente)
            this.$nextTick(()=>M.AutoInit())
          }
        }).catch(error => {
          console.log(error)
        })
      },
      registrar() {
        console.log(typeof this.selectedLider)
        if(this.username.trim().length===0 || this.nombre.trim().length===0 || this.password.trim().length===0) return M.toast({html: 'Introduce todos los campos', classes: 'rounded', displayLength: 3000})
        if (this.password!==this.confirmPassword) return M.toast({html: 'Las contraseñas no coinciden', classes: 'rounded', displayLength: 3000})
        if (this.numeroTel && !parseInt(this.numeroTel) ) return M.toast({html: 'Número telefónico no válido', classes: 'rounded', displayLength: 3000})
        if(this.nivel==='3' && this.selectedCliente==='0') return M.toast({html: 'Selecciona un cliente para ese nivel de usuario', classes: 'rounded', displayLength: 3000})
        this.$store.commit('ponerBarra')
        registrarUsuario(this.username,this.nombre,this.password,this.nivel, this.selectedLider, this.selectedCliente, this.maxRecargas, parseInt(this.numeroTel)).then(()=>{
          this.$store.commit('quitarBarra')
          this.mensaje='Registrado correctamente'
          this.limpiarRegistro()
        }).catch(error=>{
          this.$store.commit('quitarBarra')
          console.log(error)
          this.mensaje=error.mensaje
        })
      },
      editar(){
        if (!this.usuarioSeleccionado.nombre) return M.toast({html: 'Selecciona un usuario', classes: 'rounded', displayLength: 3000})
        if (this.numeroTele && !parseInt(this.numeroTele) ) return M.toast({html: 'Número telefónico no válido', classes: 'rounded', displayLength: 3000})
        if(this.nombreEditar.trim().length===0 || this.passwordEditar.trim().length===0) return M.toast({html: 'Introduce todos los campos', classes: 'rounded', displayLength: 3000})
        if (this.passwordEditar!==this.confirmarPasswordEditar) return M.toast({html: 'Las contraseñas no coinciden', classes: 'rounded', displayLength: 3000})
        this.$store.commit('ponerBarra')
        if (this.passwordEditar==='......') {
          this.passwordEditar=undefined
          this.confirmarPasswordEditar=undefined
        }
        editarUsuario(this.nombreEditar,this.passwordEditar,this.nivelEditar,this.usuarioValue, this.selectedLiderEditar, this.selectedClienteEditar, this.maxRecargasEditar, parseInt(this.numeroTele)).then(()=>{
         if(this.passwordEditar===undefined){
           this.passwordEditar='......'
           this.confirmarPasswordEditar='......'
         }
          this.$store.commit('quitarBarra')
          this.mensaje='Editado correctamente'
          //this.usuarioValue = '0'
          this.getUsers()
        }).catch(error=>{
          this.$store.commit('quitarBarra')
          console.log(error)
          this.mensaje=error.mensaje
        })
      },
      limpiarRegistro(){
        this.username=''
        this.nombre=''
        this.password=''
        this.confirmPassword=''
        this.clientes=[]
        this.selectedLider='0'
      },
      limpiarEditar(){
        this.nombreEditar=''
        this.passwordEditar=''
        this.confirmarPasswordEditar=''
        this.nivelEditar='1'
      },
      eliminar(){
        eliminarUsuario(this.usuarioValue).then(()=>{
          this.$store.commit('quitarBarra')
          M.toast({html: 'Eliminado correctamente', classes: 'rounded', displayLength: 5000})
          this.usuarioSeleccionado={nombre:''}
          this.getUsers()
          this.usuarioValue = '0'
        }).catch(error=>{
          this.$store.commit('quitarBarra')
          console.log(error)
          this.mensaje=error.mensaje
        })
      }
    },
    watch:{
      usuarioValue(id){
        console.log(123)
        if (id==='0') return this.limpiarEditar()
        this.mensaje=''
        this.usuarioSeleccionado = this.usuarios.find(usr=>usr.id===id)
        console.log(this.usuarioSeleccionado)
        this.nombreEditar = this.usuarioSeleccionado.nombre || ''
        this.passwordEditar = '......'
        this.confirmarPasswordEditar='......'
        this.numeroTele = this.usuarioSeleccionado.phoneNumber && this.usuarioSeleccionado.phoneNumber != `null` ?  this.usuarioSeleccionado.phoneNumber :  ''
        this.nivelEditar=this.usuarioSeleccionado.nivel || '1'
        this.selectedLiderEditar=this.usuarioSeleccionado.lider || '0'
        this.selectedClienteEditar=this.usuarioSeleccionado.cliente || '0'
        this.maxRecargasEditar = this.usuarioSeleccionado.maxRecargas || '10'
        this.$nextTick(()=> {
          M.AutoInit()
          M.updateTextFields()
        })
      },
      selectedLider(val){
        this.clientes = clientesStore.filter(clienteLider=>clienteLider.lider===val).map(clienteLider=>clienteLider.cliente)
        this.$nextTick(()=>M.AutoInit())
      },
      selectedLiderEditar(val){
        this.clientes = clientesStore.filter(clienteLider=>clienteLider.lider===val).map(clienteLider=>clienteLider.cliente)
        this.$nextTick(()=>M.AutoInit())
      },
      permisos(){
        this.$nextTick(()=>M.AutoInit())
      }
    },
    beforeCreate(){
      if (localStorage.nivel==='3') return this.$router.push({name: 'login',params:{empresa:localStorage.empresa}})
    },
    computed: {
      ...mapState(['permisos'])
    },
  }
</script>

<style scoped>
  .titulo {
    font-size: 2.2em;
    display: block;
    margin-top: 5px;
    font-family: "Roboto",serif;
    font-weight: lighter;
  }

  .prefix {
    font-size: 1.4em;
    margin-top: 10px;
  }

  .card-panel {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .icono-izquierda {
    left: 0;
  }

  .left {
    margin-left: 10px;
  }

  .recargas{
    width: 31%;
    margin-left: 3%;
  }

  .movimientos{
    width: 60%;
    margin-left: 3%;
    overflow-y: auto;
    max-height: 85vh;
  }

  .main{
    margin-top: 20px;
  }

  .mensaje-error {
    font-size: 1.5em;
    margin-bottom: 15px;
    font-family: "Roboto", serif;
    color: #b80009;
  }

  .eliminar{
    margin-top: -70px;
    margin-right: 8px;
  }
  .boton-margen-derecho{
    margin-right: 10px;
  }
  .boton-margen-izquierdo{
    margin-left: 10px;
  }

  .input-field{
    margin-top: 0.6rem;
    margin-bottom: 0.6rem;
  }

  .card-panel{
    padding-top: 5px;
  }
  .icons-in-form{
    margin-left: -10px !important;
  }

  @media (max-width: 900px) {
    .recargas{
      width: 92%;
      margin-left: 4%;

    }

    .movimientos{
      width: 92%;
      margin-left: 4%;
    }
  }

</style>
